module.exports = __webpack_public_path__ + "static/media/icon-nav-arrow.db563bc4.svg";